<template lang="pug">
.container-fluid
  //- h1 Return Addresses    
  .card.shadow.mb-4
    // Card Header - Dropdown
    .card-header.py-3.d-flex.flex-row.align-items-center.justify-content-between
      h2.m-0.font-weight-bold.text-primary Return Addresses
      button.btn.btn-primary.text-right(v-on:click="openAddress()")  
        i.fas.fa-fw.fa-plus-square
        |Address
    .card-body
      .col-12.table-wrap    
        div(style="text-align:center" v-if="loading")
          Spinner(size="medium" message="Loading...")
        transition( name="fade")
          table#tablePreview.table(v-if="!loading")
            // Table head
            thead
              tr
                th Actions
                th Name
                th Sender
                th Company
                th City
                th Country
                th Address
                th Postal Code
            tbody
              tr(v-for="(address, index) in addresses")
                th.addressAction(scope='row')
                  i.fas.fa-fw.fa-edit(v-on:click="editAddresses(index)" title="Edit Address")
                  i.fas.fa-fw.fa-minus-circle(v-on:click="deleteAddress(index)" title="Delete Address")
                  //- i.fas.fa-fw.fa-check-double(v-on:click="defaultAddress(index)" title="Set as Default")
                td {{address.name}}
                td {{address.sender}}
                td {{address.company}}
                td {{address.city}}
                td {{address.countryCode}}
                td {{address.address1}}
                td {{address.postalCode}}
                
      
      .col-12.text-center(style="display:flex;justify-content:center")
        ul.pagination
          li.page-item.nav-item(title="First Page")
            a.page-link( aria-label='Previous' v-on:click="firstPage()")
              span(aria-hidden='true') «
              span.sr-only Previous
          li.page-item.nav-item
            a.page-link( v-if="page >1" v-on:click="prevPage()") {{page - 1}}
          li.page-item.nav-item
            a.page-link(style="font-weight:bold") {{page}}
          li.page-item.nav-item
            a.page-link( v-if="page < maxPage" v-on:click="nextPage()") {{page + 1}}
          li.page-item.nav-item(v-bind:title="`Last Page: ${maxPage}`")
            a.page-link(aria-label='Next')
              span(aria-hidden='true' v-on:click="lastPage()") »
              span.sr-only Next
      transition( name="fade")
        .addressFormWrap(v-if="addressForm")
          .addressContainer
            .addressgogo(ref="returnAddressForm")
              ReturnAddress(
                :gandalf="false"
                :addressInfo="addressInfo"
                :editAddress="editAddress"
                @addressSaved="addressSaved"
                @closeAddress="closeAddress"
                @addressScrollTop="addressScrollTop"
                @init="init"
              )
          .addressFormBg(v-on:click="closeAddress")
</template>

<script>
import ReturnAddress from '@/components/ReturnAddress'
import Spinner from 'vue-simple-spinner'

export default {
  name: 'ReturnAddresses',
  props: {

  },
  components:{
    ReturnAddress,
    Spinner,
  },
  metaInfo: {
    title: 'Return Addresses',
  },
  data:function(){
    return{
      addresses:[],
      page:1,
      limit:25,
      offset:0,
      loading:true,
      addressForm:false,
      maxPage:1,
      addressInfo:null,
      editAddress:false,
      successMsg:null,
    }
  },
  methods:{
    async init(){
      this.loading = true;
      this.axios.get(`/rp/server/return_address/count`)
      .then(response=>{      
        this.maxPage = Math.ceil(response.data.count / this.limit)
      })
      var skipNo = this.page - 1
      this.offset = this.limit * skipNo
      this.axios.get(`/rp/server/return_address/?limit=${this.limit}&offset=${this.offset}`)
      .then(response=>{
        this.addresses = response.data
        this.loading = false
      })
    },
    nextPage(){
      this.page ++
      this.init();
    },
    prevPage(){
      this.page --
      this.init();
    },
    firstPage(){
      this.page = 1
      this.init();
    },
    lastPage(){
      this.page = this.maxPage;
      this.init()
    },

    editAddresses(address){
      this.addressInfo = this.addresses[address];
      this.editAddress = true;
      this.addressForm = true
    },
    async deleteAddress(address){
      var x = confirm('Are you sure you want to delete?')
      var data = new FormData()
      data.append(`returnAddressId`, `${this.addresses[address]._id}`)
      if (x){
        var del = await this.axios.post(`/rp/server/return_address/delete/?`,data)
        if (del.data.error) this.flash( del.data.error.message,'error')
        else{
          var update = await this.init();
        }
      }
    },
    // defaultAddress(address){},
    addressScrollTop(){
       this.$refs.returnAddressForm.scrollTop = 0;
    },
    openAddress(){
      this.addressForm = true;

    },
    closeAddress(){
      this.addressForm = false;
      this.addressInfo = null;
      this.editAddress = false;
    },
    addressSaved(){
      alert('saved')
    },
  },
  async created(){
    await this.init();
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.addressAction{
  display:flex;
  i{
    margin-right:5px;
  }
}
.table-wrap{
  overflow:auto;
}
  .addressFormWrap{
    position:fixed;
    display:flex;
    justify-content: center;
    align-items: center;
    width:100vw;
    height:100vh;
    top:0;
    left:0;
    .addressContainer{
      width:60vw;
      max-height:800px;
      padding:10px 0px;
      background:white;
      border-radius: 10px;      
      box-shadow: 0px 0px 10px 1px rgba(0,0,0,.5);
      z-index: 9;
      .addressgogo{
        max-width:80vw;
        max-height:80vh;
        overflow:auto;
        border-radius: 5px;
      }
    }
    .addressFormBg{
      width:100%;
      height:100%;
      z-index: -1;
      position: absolute;
      top:0;
      background:rgba(0,0,0,.2);
    }

  }
 th{
   i{
     cursor: pointer;
     margin-right:5px;
   }
 }
 @media all and (max-width:768px){
  .card-header{
    flex-flow:wrap;
  }
  .addressFormWrap{
    width:100vw;
    height:100vh;
    top:0;
    left:0;
    .addressContainer{
      width:90vw;
      .addressgogo{
        max-width:90vw;
        max-height:80vh;
        overflow:auto;
        border-radius: 5px;
      }
    }
    .addressFormBg{
      width:100%;
      height:100%;
      z-index: -1;
      position: absolute;
      top:0;
      background:rgba(0,0,0,.2);
    }

  }
 }
</style>
